import { TemplateJson, TemplateUserInput } from './template.model';

export interface ReportTemplate {
  id: string;
  name: string;
  entityType: string;
  organizationLevelId?: string;
  templateJson: TemplateJson;
  isActive: boolean;
  isShared: boolean;
  isDefault: boolean;
  createdBy: string;
  createdByUserId?: string;
  canManage: boolean;
  createdDate: string;
  updatedBy?: string;
  updatedAt?: string;
  entityTypeLabel?: string;
}

export {
  TemplateJson,
  TemplateAsset,
  TemplatePrintOptions,
  TemplateUserInput,
  TemplateSupportedFilter,
  ReportTemplateJson
} from './template.model';

export interface UserInputField extends TemplateUserInput {
  options?: string[];
}

export interface TemplateContext {
  entities?: Record<string, unknown>;
  computedData?: Record<string, unknown>;
  userInputs?: Record<string, string | boolean>;
  reportGeneratedBy?: string;
  reportGeneratorTitle?: string;
  generatedAt?: string;
  copyrightYear?: string;
  [key: string]: unknown;
}

const LEGACY_MARGIN_SEEDS = new Set(['5mm', '10mm']);

export function normalizeLegacyMargins(margins: string | undefined | null): string {
  if (!margins || LEGACY_MARGIN_SEEDS.has(margins)) return '0mm';
  return margins;
}
